import { render, staticRenderFns } from "./brandInfo.vue?vue&type=template&id=255786f7&scoped=true&"
import script from "./brandInfo.vue?vue&type=script&lang=js&"
export * from "./brandInfo.vue?vue&type=script&lang=js&"
import style0 from "./brandInfo.vue?vue&type=style&index=0&id=255786f7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255786f7",
  null
  
)

export default component.exports